module.exports = __webpack_public_path__ + "../resources/img/ic_info.6d44e70d.svg";